import { createFileRoute } from "@tanstack/react-router";
import { KarrierePage, karriereHead } from "@/pages/KarrierePage";

export const Route = createFileRoute("/karriere")({
  head: () => karriereHead("da"),
  component: () => <KarrierePage locale="da" />,
});
